import appEvents from 'events/app';
import evaluateInitialCompositionStage from 'actions/configuration/evaluateInitialCompositionStage';
import evaluateRules from 'actions/configuration/evaluateRules';
import evaluateStage from 'actions/configuration/evaluateStage';

export default function initializeApp(dispatch) {
  dispatch(appEvents.appInitialized());
  dispatch(evaluateInitialCompositionStage);
  dispatch(evaluateRules);
  dispatch(evaluateStage);
}
